const initState = {
  course: [],
  
  
};

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initState, action) => {
  switch (action.type) {
    
    case "COURSEDATA": {
      return {...state, course:action?.payload }
    }    
    case "LOGOUT": {

      localStorage.clear()
      return {...state, course:null }
       
        
      
    }

    
    default: {
      return state;
    }
  }
};


